// extracted by mini-css-extract-plugin
module.exports = {"s13jnl64":"s13jnl64"};